import React from "react";
import { Form } from "antd";
import { ICourtCase } from "../../model/CourtCase";
import DataGrid from "../../../core/ui/components/grid/DataGrid";
import CourtCaseForm from "./CourtCaseForm";
import DataGridConfigurationBuilder from "../../../core/ui/components/grid/DataGridConfigurationBuilder";
import { ICourtCaseConnectionType } from "../../model/CourtCaseConnectionType";
import CreateModal from "../../../core/ui/components/grid/CreateModal";
import CourtCaseCreationForm from "./CourtCaseCreationForm";
import { CourtCaseType } from "../../common/Constants";
import { IGenericCodebookItem } from "../../../codebooks/model/GenericCodebookItem";
import { ICaseDecision } from "../../../caseDecisions/model/CaseDecision";

interface CourtCaseGridProps {
  translate: any;
  courtCases: ICourtCase[];
  createCourtCase: any;
  referenceLoader?: boolean;
  removeCourtCase;
  courtCaseConnectionTypeList: ICourtCaseConnectionType[];
  updateCourtCaseSelection;
  courtCaseSelectionResult;
  createCourtCasePopupVisible;
  createCourtCaseModalVisible;
  showCreateCourtCasePopupVisible;
  showCreateCourtCaseModalVisible;
  findCourtCase;
  nonExistantCourtCaseNumber;
  createCourtCaseAttachment;
  uploadedCourtCaseAttachment;
  createConnectedCourtCase;
  courtCaseTypes: IGenericCodebookItem[];
  decisionTypes: IGenericCodebookItem[];
  selectedCaseDecision?: ICaseDecision;
  onSelectCaseDecision(courtCase: ICourtCase, value: ICaseDecision);
}
const CourtCaseGrid: React.FC<CourtCaseGridProps> = ({
  translate,
  courtCases,
  createConnectedCourtCase,
  referenceLoader,
  removeCourtCase,
  courtCaseConnectionTypeList,
  updateCourtCaseSelection,
  courtCaseSelectionResult,
  createCourtCaseModalVisible,
  showCreateCourtCaseModalVisible,
  nonExistantCourtCaseNumber,
  createCourtCaseAttachment,
  uploadedCourtCaseAttachment,
  findCourtCase,
  createCourtCase,
  courtCaseTypes,
  decisionTypes,
  selectedCaseDecision,
  onSelectCaseDecision
}) => {
  const builder = DataGridConfigurationBuilder({
    translate,
    resourcePrefix: "editors.case_law_documents.connected_cases"
  });
  const columns = builder.buildColumns(
    {
      name: "court_case_number",
      dataKey: "courtCaseNumber"
    },
    {
      name: "case_description",
      dataKey: "caseDescription"
    },
    {
      name: "connection_type",

      render: (record) => (
        <div>
          {
            courtCaseConnectionTypeList.find(
              (item) => record.connectionTypeId === item.id
            )?.name
          }
        </div>
      )
    }
  );

  const [CreateForm] = Form.useForm();
  const [CreateCaseDecisionForm] = Form.useForm();

  return (
    <div>
      <DataGrid
        columns={columns}
        translate={translate}
        dataSource={courtCases || []}
        createActionPosition="topRight"
        allowCreate={true}
        addButtonText="Novi zapis"
        allowDelete={true}
        onCancelCreateModal={() => {
          CreateForm.resetFields();
          findCourtCase(undefined);
          return false;
          //onSelectCaseDecision(courtCaseSelectionResult, null);
        }}
        createForm={
          <CourtCaseForm
            selectedCaseDecision={selectedCaseDecision}
            translate={translate}
            form={CreateForm}
            connectionTypes={courtCaseConnectionTypeList}
            updateCourtCaseSelection={updateCourtCaseSelection}
            courtCaseSelectionResult={courtCaseSelectionResult}
            findCourtCase={findCourtCase}
            decisionTypes={decisionTypes}
            onSelectCaseDecision={onSelectCaseDecision}
          />
        }
        loading={referenceLoader}
        onCreate={(e) => {
          createConnectedCourtCase(e);
        }}
        onDelete={(e) => {
          removeCourtCase(e.courtCaseNumber);
        }}
        booleanColumnKeys={["valid"]}
        createModalClass={"modal-width"}
        createModalTitle={translate(
          "editors.case_law_documents.connected_cases.add_new_connected_case"
        )}
        keyProperty={"courtCaseNumber"}
        CreateFormInstance={CreateForm}
        deleteModalMessage={translate(
          "editors.case_law_documents.court_case_delete_message"
        )}
        deleteModalTitle={translate("editors.case_law_documents.delete_title")}
      />
      <CreateModal
        translate={translate}
        title={translate("editors.court_cases.add_new_court_case")}
        visible={createCourtCaseModalVisible}
        onCreate={(item: ICourtCase) => {
          createCourtCase(item);
          CreateCaseDecisionForm.resetFields();
          showCreateCourtCaseModalVisible(false);
        }}
        onCancel={() => {
          CreateCaseDecisionForm.resetFields();
          showCreateCourtCaseModalVisible(false);
        }}
        Form={
          <CourtCaseCreationForm
            translate={translate}
            form={CreateCaseDecisionForm}
            setFileValue={createCourtCaseAttachment}
            uploadedAttachment={uploadedCourtCaseAttachment}
            courtCaseTypes={courtCaseTypes}
            decisionTypes={decisionTypes}
          />
        }
        style={{ position: "relative", zIndex: 999 }}
        formInstance={CreateCaseDecisionForm}
        className={"modal-width"}
        rowData={{
          type: CourtCaseType.CONNECTED,
          courtCaseNumber: nonExistantCourtCaseNumber ?? ""
        }}
      />
    </div>
  );
};
export default CourtCaseGrid;
